var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"hetong"},[_vm._v(" 签约合同内容："),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.look}},[_vm._v("查看合同")])],1),_c('VuePdf',{ref:"myPdf"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }